var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLendFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E44E4E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m24.74 10.3-1.021.429a7.783 7.783 0 0 1-4.531.458l-1.393-.276a4.296 4.296 0 0 1-2.704-1.782v0m9.649-4.235-.124.03a6.574 6.574 0 0 1-4.098-.327v0a6.574 6.574 0 0 0-2.546-.514h-.162c-1.45 0-2.87.428-4.078 1.23L9.18 8.333c-.325.215-.52.58-.52.97v0c0 .574.417 1.062.984 1.15l.38.06c.242.037.489.02.722-.052l4.346-1.332m0 0 4.206-1.262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF3030",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20.699 20a5 5 0 1 1-5-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1A7A7",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18.866 17.083h4.333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendFee);
export default __webpack_public_path__ + "static/media/lendFee.33e1f7dbccfddf6665f6f9001a981aab.svg";
export { ForwardRef as ReactComponent };